import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import VueAxios from "vue-axios";
import VueTypedJs from 'vue-typed-js';
import vueSmoothScroll from "vue2-smooth-scroll"

Vue.use(vueSmoothScroll);

Vue.use(VueTypedJs);
Vue.config.productionTip = false;
Vue.use(VueAxios, axios);

export function prettyMoney(num: number) {
    return (num == null || isNaN(num)) ? "N/a" : "£" + Number(num).toLocaleString();
}

export function prettyMoneyThousands(num: number) {
    return isNaN(num) 
        ? "N/a" 
        : "£" + Number(num/1000).toFixed(num < 100000 ? 1 : 0).toLocaleString() + "K";
}

export function prettyPercent(num: number) {
    return isNaN(num) ? "N/a" : Math.round(Number(num) * 100) + '%';
}

export function prettyInterestRate(num: number) {
    return isNaN(num) ? "N/a" : Number(num).toLocaleString() + '%';
}

Vue.filter('prettyNumber', function (num: number) {
    return isNaN(num) ? "N/a" : Number(num).toLocaleString();
});

Vue.filter('prettyMoney', function (num: number) {
    return prettyMoney(num);
});

Vue.filter('prettyMoneyThousands', function (num: number) {
    return prettyMoneyThousands(num);
});

Vue.filter('prettyInterestRate', function (num: number) {
    return prettyInterestRate(num);
});

Vue.filter('prettyPercent', function (num: number) {
    return prettyPercent(num);
});

import { PopoverPlugin } from 'bootstrap-vue'
Vue.use(PopoverPlugin)

import { OverlayPlugin } from 'bootstrap-vue'
Vue.use(OverlayPlugin)

import { ModalPlugin } from 'bootstrap-vue'
Vue.use(ModalPlugin)

import { SidebarPlugin } from 'bootstrap-vue'
Vue.use(SidebarPlugin)

import { TabsPlugin } from 'bootstrap-vue'
Vue.use(TabsPlugin)

import { FormDatepickerPlugin } from 'bootstrap-vue'
Vue.use(FormDatepickerPlugin)

import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

import money from 'v-money'
Vue.use(money, {
    decimal: ',',
    thousands: ',',
    prefix: '£ ',
    suffix: '',
    precision: 0,
    masked: false
});

import 'primevue/resources/themes/saga-blue/theme.css';
import 'primevue/resources/primevue.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';

// Import the Auth0 configuration
import { domain, clientId } from "./auth_config.json";

// Import the plugin here
import { Auth0Plugin } from "./auth";

// Install the authentication plugin here
Vue.use(Auth0Plugin, {
    domain,
    clientId,
    onRedirectCallback: function(appState: any) {
        router.push(
            appState && appState.targetUrl
                ? appState.targetUrl
                : window.location.pathname
        );
    }
});

new Vue({
    router,
    store,
    render: h => h(App),
    created() {
        this.$store.dispatch("loadLenders").then(() => {
            console.log("Lenders loaded");
        });
        // this.$store.dispatch("login").then(() => {
        //     console.log("Default user logged in"); 
        // });
        // this.$store.dispatch("loadMortgageWatchers", "matthew_braid@hotmail.com").then(() => {
        //    console.log("Loaded the MortgageWatchers"); 
        // });
    }
}).$mount("#app");
